// ----------------
// UI Modules - Global
// ----------------
// This is UI modules for Global instances
// ---------------------------------------------------------------

import listViewToggle from './listViewToggle'
import newsletter from './newsletter'
import toggleDownloadButton from './toggleDownloadButton'
import quotesCarousel from './quotesCarousel'
import setStoreHours from './locationsHours'
import locationGoogleMap from './locationsGoogleMap'
import crunchBanner from './crunchBanner'
import header from './header'
import locationSearch from './locationSearch'
import menuNav from './menuNav'
import carousel from './carousel';
import favoriteLocation from './favoriteLocation'

function init() {
  listViewToggle()
  newsletter()
  toggleDownloadButton()
  quotesCarousel()
  setStoreHours()
  locationGoogleMap()
  crunchBanner()
  header()
  locationSearch()
  menuNav()
  carousel()
  favoriteLocation()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/index.js